<template>
  <tr class="item-row po-item-row">
    <!-- <td colspan="6"> -->
      <td colspan="4">
      <table class="full-width">
        <colgroup>
          <col style="width: 2%;">
          <!-- <col style="width: 20%;">
          <col style="width: 20%;"> -->

          <col style="width: 35%;">
          <col style="width: 35%;">
          <col style="width: 10%;">
          <!-- <col style="width: 15%;">
          <col style="width: 15%;"> -->
        </colgroup>
        <tbody>
          <tr>
            <td>
              <div class="sort-icon-wrapper handle">
                <input
                  v-if="POHasItems"
                  :id="item.systemItemId"
                  v-model="selectFieldItem"
                  :value="item.systemItemId"
                  type="checkbox"
                >
                <font-awesome-icon
                    v-else
                    class="sort-icon"
                    icon="grip-vertical"
                  />
              </div>
            </td>
            <td class="">
              <div class="item-select-wrapper">
                <item-select-through-name
                  ref="itemSelect"
                  :invalid="$v.item.name.$error"
                  :invalid-description="$v.item.description.$error"
                  :item="item"
                  :index="index"
                  :tax-per-item="taxPerItem"
                  :taxes="item.taxes"
                  @search="searchVal"
                  @select="onSelectItem"
                  @deselect="deselectItem"
                  @onDesriptionInput="$v.item.description.$touch()"
                  @onSelectItem="isSelected = true"
                />
              </div>
            </td>
            <td>
              <item-select-through-part-number
                  ref="itemSelect"
                  :invalid="$v.item.name.$error"
                  :invalid-description="$v.item.description.$error"
                  :item="item"
                  :index="index"
                  :tax-per-item="taxPerItem"
                  :taxes="item.taxes"
                  @search="searchVal"
                  @select="onSelectItem"
                  @deselect="deselectItem"
                  @onDesriptionInput="$v.item.description.$touch()"
                  @onSelectItem="isSelected = true"
                />
            </td>
            <td class="text-left" >
              <base-input
                v-model="item.quantity"
                :invalid="$v.item.quantity.$error"
                type="text"
                small
                @keyup="updateItem(item, index)"
                @input="$v.item.quantity.$touch()"
              />
              <div v-if="$v.item.quantity.$error">
                <span v-if="!$v.item.quantity.maxLength" class="text-danger">{{ $t('validation.quantity_maxlength') }}</span>
              </div>
            </td>
            <!-- <td class="text-left">
              <div class="d-flex flex-column">
                <div class="flex-fillbd-highlight">
                  <div class="base-input">
                    <money
                      v-model="price"
                      v-bind="customerCurrency"
                      class="input-field"
                      @input="$v.item.price.$touch()"
                    />
                  </div>
                  <div v-if="$v.item.price.$error">
                    <span v-if="!$v.item.price.maxLength" class="text-danger">{{ $t('validation.price_maxlength') }}</span>
                  </div>
                </div>
              </div>
            </td> -->
            <td class="text-right">
              <div class="item-amount">
                <!-- <span>
                  <div v-html="$utils.formatMoney(total, currency)" />
                </span> -->
                <div class="remove-icon-wrapper">
                  <font-awesome-icon
                    v-if="isShowRemoveItemIcon"
                    class="remove-icon"
                    icon="trash-alt"
                    @click="removeItem(item, index)"
                  />
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </td>
  </tr>
</template>
<script>
import Guid from 'guid'
import { validationMixin } from 'vuelidate'
import { mapActions, mapGetters } from 'vuex'
import TaxStub from '../../stub/tax'
import DeliveryNoteStub from '../../stub/deliveryNote'
import ItemSelectThroughName from './ItemSelectThroughName'
import ItemSelectThroughPartNumber from './ItemSelectThroughPartNumber'
import Tax from './Tax'

const { required, minValue, between, maxLength, alphaNum } = require('vuelidate/lib/validators')

export default {
  components: {
    Tax,
    ItemSelectThroughName,
    ItemSelectThroughPartNumber
  },
  mixins: [validationMixin],
  props: {
    itemData: {
      type: Object,
      default: null
    },
    index: {
      type: Number,
      default: null
    },
    type: {
      type: String,
      default: ''
    },
    currency: {
      type: [Object, String],
      required: true
    },
    taxPerItem: {
      type: String,
      default: ''
    },
    discountPerItem: {
      type: String,
      default: ''
    },
    orderItems: {
      type: Array,
      required: true
    },
    ItemId:{
      type: String,
      required: true
    }
  },
  data () {
    return {
      isClosePopup: false,
      itemSelect: null,
      item: {...this.itemData},
      maxDiscount: 0,
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '$ ',
        precision: 2,
        masked: false
      },
      isSelected: false
    }
  },
  computed: {
    ...mapGetters('item', [
      'items'
    ]),
    ...mapGetters('modal', [
      'modalActive'
    ]),
    ...mapGetters('currency', [
      'defaultCurrencyForInput'
    ]),
    ...mapGetters('deliveryNote', [
      'selectedDeliveryNoteItems',
      'POItems',
      'deliveryNoteItems',
      'deliveryNoteItemsStatus',
      'POHasItems'
    ]),
    selectFieldItem: {
      get: function () {
        return this.selectedDeliveryNoteItems
      },
      set: function (val) {
        this.selectedDeliveryNoteItem(val)
      }
    },

    customerCurrency () {
      if (this.currency) {
        return {
          decimal: this.currency.decimal_separator,
          thousands: this.currency.thousand_separator,
          prefix: this.currency.symbol + ' ',
          precision: this.currency.precision,
          masked: false
        }
      } else {
        return this.defaultCurrencyForInput
      }
    },
    isShowRemoveItemIcon () {
      if (this.orderItems.length == 1) {
        return false
      }
      return true
    },
    subtotal () {
      return this.item.price * this.item.quantity
    },
    discount: {
      get: function () {
        return this.item.discount
      },
      set: function (newValue) {
        if (this.item.discount_type === 'percentage') {
          this.item.discount_val = (this.subtotal * newValue) / 100
        } else {
          this.item.discount_val = newValue * 100
        }

        this.item.discount = newValue
      }
    },
    total () {
      return this.subtotal - this.item.discount_val
    },
    totalSimpleTax () {
      return window._.sumBy(this.item.taxes, function (tax) {
        if (!tax.compound_tax) {
          return tax.amount
        }

        return 0
      })
    },
    totalCompoundTax () {
      return window._.sumBy(this.item.taxes, function (tax) {
        if (tax.compound_tax) {
          return tax.amount
        }

        return 0
      })
    },
    totalTax () {
      return this.totalSimpleTax + this.totalCompoundTax
    },
    price: {
      get: function () {
        if (parseFloat(this.item.price) > 0) {
          return this.item.price / 100
        }

        return this.item.price
      },
      set: function (newValue) {
        if (parseFloat(newValue) > 0) {
          this.item.price = newValue * 100
          this.maxDiscount = this.item.price
        } else {
          this.item.price = newValue
        }
      }
    }
  },
  watch: {
    // item: {
    //   handler: 'updateItem',
    //   deep: true
    // },
    // subtotal (newValue) {
    //   if (this.item.discount_type === 'percentage') {
    //     this.item.discount_val = (this.item.discount * newValue) / 100
    //   }
    // },
    modalActive (val) {
      if (!val) {
        this.isSelected = false
      }
    }
  },
  validations () {
    return {
      item: {
        name: {
          required
        },
        quantity: {
          required,
          minValue: minValue(1),
          maxLength: maxLength(20)
        },
        price: {
          required,
          minValue: minValue(1),
          maxLength: maxLength(20)
        },
        part_number:{
          required
        },
        discount_val: {
          between: between(0, this.maxDiscount)
        },
        description: {
          maxLength: maxLength(255)
        }
      }
    }
  },
  created () {
    window.hub.$on('checkItems', this.validateItem)
    window.hub.$on('newItem', (val) => {
      if (this.taxPerItem === 'YES') {
        this.item.taxes = val.taxes
      }
      if (!this.item.item_id && this.modalActive && this.isSelected) {
        this.onSelectItem(val)
      }
    })
  },
  methods: {
     ...mapActions('deliveryNote', [
      'selectedDeliveryNoteItem',
      'removeDeliveryNoteItem',
      'updateDeliveryNoteItem',
      'removeInPOItems',
      'addInPOItems',
      'tempDeleteItem',
      'tempAddItem'
    ]),
    ...mapActions('item', [
      'fetchItems',
    ]),

    updateTax (data) {
      this.$set(this.item.taxes, data.index, data.item)

      let lastTax = this.item.taxes[this.item.taxes.length - 1]

      if (lastTax.tax_type_id !== 0) {
        this.item.taxes.push({...TaxStub, id: Guid.raw()})
      }

      this.updateItem()
    },
    removeTax (index) {
      this.item.taxes.splice(index, 1)

      this.updateItem()
    },
    taxWithPercentage ({ name, percent }) {
      return `${name} (${percent}%)`
    },
    searchVal (val) {
      this.item.name = val
    },
    deselectItem (item, index) {
      this.removeItem (item, index)
    },
    onSelectItem (item) {
      console.log(item)
      this.item.name = item.name
      this.item.price = item.price
      this.item.item_id = item.id
      this.item.description = item.description
      this.item.part_number = item.part_number
      this.item.unit_name = item.unit_name
      this.item.systemItemId = item.systemItemId
      if (this.taxPerItem === 'YES' && item.taxes) {
        let index = 0
        item.taxes.forEach(tax => {
          this.updateTax({index, item: { ...tax }})
          index++
        })
      }
      if(this.POHasItems == true && this.POItems && item.deliveryNote_remainig_quantity){
        console.log('NN')
        this.item.quantity = item.deliveryNote_remainig_quantity
        item['ItemId']= this.ItemId
        item['index'] = this.index
        this.removeInPOItems(this.item)
        this.updateItem(this.item, this.index)

      }else if(this.POHasItems == true && this.POItems &&  this.deliveryNoteItemsStatus == true){
        console.log('MM')
        item['ItemId']= this.ItemId
        item['index'] = this.index
        this.item.quantity = item.quantity
        console.log(item)
          this.removeInPOItems(this.item)
          this.updateItem(this.item, this.index)
      }else if(this.POHasItems == false && this.deliveryNoteItemsStatus == true){
        console.log('ll')
        item['index'] = this.index
        this.updateItem(this.item, this.index)
        this.tempDeleteItem(this.item)
      }else if(this.POHasItems == false && this.deliveryNoteItemsStatus == false){
         console.log('KK')
        item['index'] = this.index
        this.updateItem(this.item, this.index)
        this.tempDeleteItem(this.item)
      }
    },
    selectFixed () {
      if (this.item.discount_type === 'fixed') {
        return
      }
      this.item.discount_val = this.item.discount * 100
      this.item.discount_type = 'fixed'
    },
    selectPercentage () {
      if (this.item.discount_type === 'percentage') {
        return
      }

      this.item.discount_val = (this.subtotal * this.item.discount) / 100

      this.item.discount_type = 'percentage'
    },
    updateItem (item, index) {
      console.log(item)
      item['index']=index
      item['total']=this.total
      this.$emit('update', item)
    },
    removeItem (item, index) {
      if(this.POHasItems == true &&  this.deliveryNoteItemsStatus == true){
        console.log(item)
        this.$emit('remove', item)
      }else if(this.deliveryNoteItemsStatus == true){
        item.original_item_id =item.id
        this.tempAddItem(item)
        this.$emit('remove', index)
      }else if(this.deliveryNoteItemsStatus == false){
        item.original_item_id =item.id
        this.tempAddItem(item)
        this.$emit('remove', index)
      }
    },
    validateItem () {
      this.$v.item.$touch()

      if (this.item !== null) {
        this.$emit('itemValidate', this.index, !this.$v.$invalid)
      } else {
        this.$emit('itemValidate', this.index, false)
      }
    }
  }
}
</script>
<style scoped>
  .delivery-note-create-page .item-table .item-body .item-row td {
    padding-left: 0px !important;
  }
</style>
